var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    { staticClass: "vuetify-wrapper" },
    [
      _c(
        "v-tooltip",
        {
          attrs: { left: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on }) {
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      {
                        attrs: {
                          disabled: _vm.disabled,
                          loading: _vm.loading,
                          "min-width": "30",
                          small: "",
                          title: _vm.title,
                        },
                        on: { click: _vm.toggle },
                      },
                      on
                    ),
                    [
                      _vm.is_appointment_hidden
                        ? _c("v-icon", { attrs: { small: "", color: "red" } }, [
                            _vm._v("mdi-eye-off"),
                          ])
                        : _c(
                            "v-icon",
                            { attrs: { small: "", color: "green" } },
                            [_vm._v("mdi-eye")]
                          ),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [
          _vm._v(" "),
          _c("span", [
            _vm._v("\n            " + _vm._s(_vm.title) + "\n            "),
            _c("div", [
              _vm._v(
                "Durch einen Klick wird die gesamte Gruppe " +
                  _vm._s(
                    _vm.is_appointment_hidden ? "wieder sichtbar" : "versteckt"
                  ) +
                  "."
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }